export const canShare = () => {
  return typeof navigator.share !== 'undefined'
}
